// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
	// Gets today's date
	const today = new Date();

	// Sets the property of the text element to be a string representing today's date in the user's local format
	$w("#text37").text = "© " + today.getFullYear();

});